<template lang="pug">
    .content.row.col-center.row-around 
        van-button(type='primary') 极速问诊
        van-button(type='warning', @click='toInquiry', :loading='loading2') 专家问诊
    </template>
    <script>
    export default {
        data() {
            return {
                loading2: false,
            }
        },
        methods: {
            async toInquiry() {
                this.loading2 = true
                const res = await this.$_http.post(this.$_API.TEST_ADD_ORDER)
                if (res.success) {
                    this.$router.replace({
                        path: '/pre/inquiry',
                        query: { keyID: res.data.data.remoteInquiryOrderID },
                    })
                }
            },
        },
    }
    </script>
    <style lang="stylus">
    .content
        width: 100vw
        height: 100vh
    </style>